import { useState, useRef } from "react";
import axios from "axios";
import { debounce } from "lodash";

export const usePaginatedFetch = ({ apiUrl, paramsBuilder, sendParams = {}, limit = 50 }) => {
    const [data, setData] = useState(null);
    const [options, setOptions] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");


    const fetchData = useRef(
        debounce(async (pageParam = page, searchParam = search, reset = false) => {
            if (!apiUrl) return;
            try {
                setLoading(true);

                const params = paramsBuilder
                    ? paramsBuilder(pageParam, searchParam)
                    : {
                        skip: (pageParam - 1) * limit,
                        limit,
                        searchValue: searchParam || undefined,
                        ...(sendParams || {}),
                    };

                const response = await axios.get(apiUrl, { params, auth: true });
                const respData = response?.data;

                setData(respData);

                // Determine which array to use for options
                let listArray = [];
                if (Array.isArray(respData)) listArray = respData;
                else if (sendParams.arrayKey && respData?.[sendParams.arrayKey]) {
                    listArray = respData[sendParams.arrayKey];
                }

                setOptions((prev) => (reset ? listArray : [...prev, ...listArray]));
                setHasMore(listArray.length >= limit);
            } catch (err) {
                console.error("Fetch error:", err);
            } finally {
                setLoading(false);
            }
        }, 300)
    ).current;

    // helper to trigger fetch with latest page/search
    const doFetch = (reset = false) => fetchData(page, search, reset);

    return {
        data,
        options,
        setOptions,
        page,
        setPage,
        hasMore,
        loading,
        search,
        setSearch,
        fetchData: doFetch,
    };
};
